import { useEffect } from 'react';

const SEO = ({ 
  title = 'UAV Geo Solutions - Transforming Institutions into Future-Ready Technology Centers',
  description = 'UAV Geo Solutions offers Drone Labs, Robotics & IoT Labs, DGCA RPTO Training, AR/VR Labs, and more.',
  keywords = 'drone lab, robotics lab, IoT lab, DGCA RPTO, drone training, UAV solutions',
  image = '/images/og-image.jpg',
  url = '',
  type = 'website'
}) => {
  useEffect(() => {
    const baseUrl = 'https://uavgeosolutions.com';
    const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
    const fullImage = image?.startsWith('http') ? image : `${baseUrl}${image}`;
    
    // Set document title
    document.title = title || 'UAV Geo Solutions';
    
    // Helper function to update or create meta tag
    const updateMetaTag = (selector, attribute, content) => {
      let meta = document.querySelector(selector);
      if (meta) {
        meta.setAttribute(attribute, content || '');
      } else {
        meta = document.createElement('meta');
        if (selector.includes('property=')) {
          const propName = selector.match(/property="([^"]+)"/)[1];
          meta.setAttribute('property', propName);
        } else if (selector.includes('name=')) {
          const name = selector.match(/name="([^"]+)"/)[1];
          meta.setAttribute('name', name);
        }
        meta.setAttribute(attribute, content || '');
        document.head.appendChild(meta);
      }
    };
    
    // Basic meta tags
    updateMetaTag('meta[name="description"]', 'content', description);
    updateMetaTag('meta[name="keywords"]', 'content', keywords);
    
    // Open Graph tags
    updateMetaTag('meta[property="og:title"]', 'content', title);
    updateMetaTag('meta[property="og:description"]', 'content', description);
    updateMetaTag('meta[property="og:image"]', 'content', fullImage);
    updateMetaTag('meta[property="og:url"]', 'content', fullUrl);
    updateMetaTag('meta[property="og:type"]', 'content', type);
    
    // Twitter tags
    updateMetaTag('meta[name="twitter:title"]', 'content', title);
    updateMetaTag('meta[name="twitter:description"]', 'content', description);
    updateMetaTag('meta[name="twitter:image"]', 'content', fullImage);
    updateMetaTag('meta[name="twitter:url"]', 'content', fullUrl);
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', fullUrl);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', fullUrl);
      document.head.appendChild(canonical);
    }
    
  }, [title, description, keywords, image, url, type]);

  return null;
};

export default SEO;
